<div class="full-width py-2 px-3" fxLayout="column" fxLayoutAlign="start start">
  <div class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px">
    <div class="full-width mb-0" fxLayout="row" fxLayoutAlign="end center">
      <button class="button-close-top" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="full-width" fxLayout="row" fxLayoutAlign="space-between start">
    <div class="subtitle-default">{{ data.header }}</div>
    <div class="pe-3" fxLayout="row" fxLayoutAlign="center center" *ngIf="loading$ | async">
      <mat-spinner color="primary" diameter="20"></mat-spinner>
    </div>
  </div>
</div>

<!-- CS-1661: the body scrolls inside the dialog so Cancel/Save below stay on screen on short viewports -->
<mat-dialog-content class="px-3" fxLayout="column">
  <div class="full-width" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="!selectedPeriod.isEditable">
    <app-info-panel [type]="PanelType.WARN"
                    [message]="['As there have been transaction within this period some fields may not be editable']">
    </app-info-panel>
  </div>

  <div fxLayout="column" class="full-width" data-test="pricing-period-form" fxLayoutGap="15px" fxFlexOffset="20px">
    <span class="heading-default">Rate types and values</span>

    <div fxLayout="row" fxLayoutGap="10px">
      <mat-form-field class="custom-select-field" appearance="outline" floatLabel="always" style="width: 40%">
        <mat-label>Fixed Rate Type</mat-label>
        <mat-select [(value)]="selectedPeriod.rentalPricingOption" [disabled]="!selectedPeriod.isEditable"
                    class="custom-select-field-value" placeholder="Select">
          @for (type of fixedRateTypes; track type.code) {
            <mat-option [value]="type.code" class="custom-select-field-option">{{type.label}}</mat-option>
          }
          @if (isEditing && selectedPeriod.rentalPricingOption == RentalPricingOption.TURNOVER_PERCENTAGE) {
            <mat-option [value]="RentalPricingOption.TURNOVER_PERCENTAGE" [disabled]="true" class="custom-select-field-option">Percentage Turnover</mat-option>
          }
          @if (isEditing && selectedPeriod.rentalPricingOption == RentalPricingOption.PRICING_MODEL) {
            <mat-option [value]="RentalPricingOption.PRICING_MODEL" [disabled]="true" class="custom-select-field-option">Fixed Rental</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="custom-text-field" appearance="outline" floatLabel="always" style="width: 40%">
        <mat-label>Fixed Rate</mat-label>
        <input [(ngModel)]="selectedPeriod.fixedRentalPricingValue" class="align-right" matInput min="0"
               [disabled]="!selectedPeriod.isEditable" type="number">
        <div matPrefix class="ms-3">R</div>
        @if (selectedPeriod.rentalPricingOption === RentalPricingOption.FIXED_PER_SQM_PER_MONTH
        || selectedPeriod.rentalPricingOption === RentalPricingOption.PRICING_MODEL
        || selectedPeriod.rentalPricingOption === RentalPricingOption.TURNOVER_PERCENTAGE) {
          <div matSuffix class="me-2"><span>/ </span><span class="ms-2">m<sup>2</sup></span></div>
        }
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutGap="10px">
      <mat-form-field class="custom-select-field" appearance="outline" floatLabel="always" style="width: 40%">
        <mat-label>Percentage Rate Type</mat-label>
        <mat-select [value]="RentalPricingOption.TURNOVER_PERCENTAGE" [disabled]="!selectedPeriod.isEditable"
                    class="custom-select-field-value" placeholder="Select">
          <mat-option [value]="RentalPricingOption.TURNOVER_PERCENTAGE" class="custom-select-field-option">Percentage Rental
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="custom-text-field" appearance="outline" floatLabel="always" style="width: 40%">
        <mat-label>% Rate</mat-label>
        <input [(ngModel)]="selectedPeriod.rentalPricingTurnoverPercentageValue" [disabled]="!selectedPeriod.isEditable"
               class="align-right"
               matInput
               type="number">
        <span matSuffix class="me-2">%</span>
      </mat-form-field>
    </div>

    <span class="heading-default">Select start and end dates for the periods</span>
    <div fxLayout="row" fxLayoutGap="15px" fxFlexAlign="space-between center">

      <mat-form-field class="custom-date-picker" appearance="outline" floatLabel="always" style="width: 40%">
        <mat-label>Start Date</mat-label>
        <input [(ngModel)]="selectedPeriod.startDate" (ngModelChange)="onStartDateChange($event)" [matDatepicker]="startPicker"
               matInput
               [min]="startDateMinValue"
               [max]="startDateMaxValue"
               placeholder="select"
        />
        <mat-datepicker-toggle matIconSuffix [for]="startPicker">
          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="custom-date-picker" appearance="outline" floatLabel="always" style="width: 40%">
        <mat-label>End Date</mat-label>
        <input [(ngModel)]="selectedPeriod.endDate" (ngModelChange)="onEndDateChange($event)" [matDatepicker]="endPicker"
               [min]="endDateMinValue"
               [max]="endDateMaxValue"
               matInput
               placeholder="select"/>
        <mat-datepicker-toggle matIconSuffix [for]="endPicker">
          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" class="full-width">
      <span class="heading-default">Transaction Fee Charges</span>
      <app-info-panel [type]="selectedPeriod.applyTransactionFee ? PanelType.INFO : PanelType.WARN"
                      [message]="['Transaction fees will ' + (selectedPeriod.applyTransactionFee ? '' : 'NOT ')  + 'be charged for all internal and external payment method sales.']">
      </app-info-panel>
    </div>

    <div fxLayout="row" fxLayoutGap="10px">
      <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
        <mat-label>Apply Transaction Fees</mat-label>
        <input matInput disabled>
        <span matPrefix class="body-1-regular-1 ms-3">{{ selectedPeriod.applyTransactionFee ? 'Yes' : 'No' }}</span>
        <div matSuffix class="me-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <mat-slide-toggle (change)="applyTransactionFee($event)"
                            [checked]="selectedPeriod.applyTransactionFee ? selectedPeriod.applyTransactionFee : false"
                            [disabled]="!selectedPeriod.isEditable"
                            color="primary"></mat-slide-toggle>
        </div>
      </mat-form-field>
    </div>

    <div fxFlexOffset="25px" fxLayout="row" *ngIf="displayPaymentMethodsTable">
      <table [dataSource]="paymentMethodsDataSource" class="custom-table" fxFlex="50" mat-table>
        <ng-container matColumnDef="table-label">
          <th *matHeaderCellDef [attr.colspan]="displayedColumns.length" class="custom-table-label"
              mat-header-cell>
            Payment Methods
          </th>
        </ng-container>


        <ng-container matColumnDef="collectionType">
          <th *matHeaderCellDef mat-header-cell> Collection Type</th>
          <td *matCellDef="let element" class="custom-table-cell"
              mat-cell>{{ utils.displayStatus(element.collectionType) }}
            - {{ element.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="transactionFeeType">
          <th *matHeaderCellDef mat-header-cell> Rate Type</th>
          <td *matCellDef="let element" class="custom-table-cell"
              mat-cell> {{ displayFeeType(element.transactionFeeType) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="transactionFee">
          <th *matHeaderCellDef mat-header-cell>Rate</th>
          <td *matCellDef="let element" class="custom-table-cell" mat-cell>
            <div class="body-1-regular-2" *ngIf="element.transactionFeeType === 'FIXED'">
              R {{ element.transactionFee ? element.transactionFee.toFixed(2) : null }}
            </div>
            <div class="body-1-regular-2"
                 *ngIf="element.transactionFeeType === 'RATE'">{{ element.transactionFee }} %
            </div>
          </td>
        </ng-container>

        <tr *matHeaderRowDef="['table-label']" class="custom-table-header" mat-header-row></tr>
        <tr *matHeaderRowDef="displayedColumns" class="custom-table-header" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;"
            class="custom-table-row btn-cursor"
            mat-row></tr>
      </table>

    </div>

    <mat-paginator #paymentMethodsPaginator *ngIf="selectedPeriod.applyTransactionFee"
                   [length]="paymentMethodsDataSource ? paymentMethodsDataSource.data.length : 0"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   [pageSize]="5"
                   class="custom-paginator"></mat-paginator>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="px-3 pb-3" fxLayoutGap="20px">
  <button mat-flat-button class="button-outline button-primary" (click)="cancelChanges()">
    <div class="button-text">Cancel</div>
  </button>
  <button mat-flat-button class="button-primary" (click)="saveChanges()">
    <div class="button-text">Save</div>
  </button>
</mat-dialog-actions>
